/* Alpha Everstrong - urun sayfasi gorsel galerisi.
   Kucuk gorsele tiklayinca buyuk gorsel degisir; buyuk gorsel parmakla,
   fareyle surukleyerek, oklarla veya klavye ok tuslariyla kaydirilir.
   Varyant secildiginde varyantin gorseline gecer. */
(function () {
  "use strict";

  function boot(g) {
    if (!g || g.dataset.galReady === "1") return;
    g.dataset.galReady = "1";

    var track = g.querySelector("[data-gal-track]");
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var thumbs = Array.prototype.slice.call(g.querySelectorAll("[data-gal-thumb]"));
    var prev = g.querySelector("[data-gal-prev]");
    var next = g.querySelector("[data-gal-next]");
    var count = g.querySelector("[data-gal-count]");
    var n = slides.length;
    var cur = -1;

    function w() { return track.clientWidth || 1; }

    function setActive(i) {
      if (i === cur) return;
      cur = i;
      thumbs.forEach(function (t, k) {
        var on = k === i;
        t.classList.toggle("on", on);
        t.setAttribute("aria-current", on ? "true" : "false");
        if (on) {
          var strip = t.parentElement;
          var left = t.offsetLeft - (strip.clientWidth - t.clientWidth) / 2;
          strip.scrollTo({ left: Math.max(0, left), behavior: "smooth" });
        }
      });
      slides.forEach(function (s, k) { s.setAttribute("aria-hidden", k === i ? "false" : "true"); });
      if (count) count.textContent = (i + 1) + " / " + n;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === n - 1;
    }

    function go(i, smooth) {
      i = Math.max(0, Math.min(n - 1, i));
      track.scrollTo({ left: i * w(), behavior: smooth === false ? "auto" : "smooth" });
      setActive(i);
    }

    var raf = 0;
    track.addEventListener("scroll", function () {
      if (drag) return;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { setActive(Math.round(track.scrollLeft / w())); });
    }, { passive: true });

    thumbs.forEach(function (t) {
      t.addEventListener("click", function () { go(parseInt(t.dataset.galThumb, 10)); });
    });
    if (prev) prev.addEventListener("click", function () { go(cur - 1); });
    if (next) next.addEventListener("click", function () { go(cur + 1); });

    track.addEventListener("keydown", function (e) {
      if (e.key === "ArrowRight") { e.preventDefault(); go(cur + 1); }
      else if (e.key === "ArrowLeft") { e.preventDefault(); go(cur - 1); }
    });

    /* Masaustunde fareyle surukleyerek kaydirma */
    var drag = null;
    track.addEventListener("pointerdown", function (e) {
      if (e.pointerType !== "mouse" || e.button !== 0 || n < 2) return;
      drag = { x: e.clientX, left: track.scrollLeft, start: cur };
      track.classList.add("is-drag");
      try { track.setPointerCapture(e.pointerId); } catch (err) {}
    });
    track.addEventListener("pointermove", function (e) {
      if (!drag) return;
      track.scrollLeft = drag.left - (e.clientX - drag.x);
    });
    function endDrag(e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      var target = drag.start;
      if (dx < -40) target = drag.start + 1;
      else if (dx > 40) target = drag.start - 1;
      drag = null;
      track.classList.remove("is-drag");
      go(target);
    }
    track.addEventListener("pointerup", endDrag);
    track.addEventListener("pointercancel", endDrag);
    track.addEventListener("dragstart", function (e) { e.preventDefault(); });

    window.addEventListener("resize", function () {
      track.scrollTo({ left: cur * w(), behavior: "auto" });
    });

    /* Varyant secilince varyantin gorseline gec */
    var map = {};
    var mapEl = g.querySelector("[data-gal-map]");
    if (mapEl) { try { map = JSON.parse(mapEl.textContent) || {}; } catch (err) { map = {}; } }
    var scope = g.closest("[data-alpha-pdp]") || document;
    scope.querySelectorAll("[data-alpha-variant] input[type=radio]").forEach(function (r) {
      r.addEventListener("change", function () {
        if (map[r.value] != null) go(map[r.value]);
      });
    });

    setActive(0);
    var checked = scope.querySelector("[data-alpha-variant] input[type=radio]:checked");
    if (checked && map[checked.value] != null && map[checked.value] !== 0) go(map[checked.value], false);
  }

  function init() { document.querySelectorAll("[data-alpha-gal]").forEach(boot); }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else { init(); }
  document.addEventListener("shopify:section:load", function (e) {
    var g = e.target.querySelector("[data-alpha-gal]");
    if (g) { g.dataset.galReady = ""; boot(g); }
  });
})();